import React from 'react';
import { config } from '@uhg-abyss/web/tools/config';
import { getSessionFromStorage } from '@src/utills/storage';

export const UniteUs = () => {
  const uniteUsEndpoint: string = config('UNITEUS_ENDPOINT')!;
  if(!uniteUsEndpoint) {
    console.error("UniteUs endpoint not found in config file");
  }

  const apiUrl: string = config('API_BASE_URL')!;
  if (!apiUrl) {
    console.error("API base URL not found in config file");
  }

  const sessionId = getSessionFromStorage();
  const uniteUsUrl: string =
    uniteUsEndpoint
    + "?iss="
    + apiUrl
    + "/fhir&launch="
    + sessionId;
  return (
    <React.Fragment>
      <iframe
        src={uniteUsUrl}
        style={{
          height: "100%",
          width: "100%",
          minHeight: 680,
        }}
      >
      </iframe>
    </React.Fragment>
  );
};

